export function listEnum(enumeration: any) {
  return Object.keys(enumeration).filter((key) => isNaN(Number(key)))
}

export function itemEnum(enumeration: any) {
  return listEnum(enumeration).map((key) => ({
    title: key,
    value: enumeration[key]
  }))
}

export function pathJoin(parts: string[], sep: string | null = null) {
  const separator = sep || '/'
  parts = parts.map((part, index) => {
    if (index) {
      part = part.replace(new RegExp('^' + separator), '')
    }
    if (index !== parts.length - 1) {
      part = part.replace(new RegExp(separator + '$'), '')
    }
    return part
  })
  return parts.join(separator)
}
